export default "__VITE_ASSET__Bfix0vYz__"